import { createSelector } from 'reselect';

import { MEASURENMENT_UNITS } from '../model';
import getPropFromModule from './getPropFromModule';

const getMeasurementUnits = createSelector(
  state => getPropFromModule(state, MEASURENMENT_UNITS),
  units => units?.toList().toJS() || [],
);

export default getMeasurementUnits;
